import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgCustomerService({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2a7 7 0 016.996 6.76L19 9h.5a2.5 2.5 0 012.5 2.5v4a2.5 2.5 0 01-2.5 2.5H19c-.22 0-.43-.035-.627-.1A7 7 0 0112 22a1 1 0 110-2 5 5 0 004.995-4.783L17 15V9a5 5 0 00-9.995-.217L7 9v7a2 2 0 01-1.85 1.994L5 18h-.5a2.5 2.5 0 01-2.495-2.336L2 15.5v-4a2.5 2.5 0 012.336-2.495L4.5 9H5a7 7 0 017-7zm-7 9h-.5a.5.5 0 00-.492.41L4 11.5v4a.5.5 0 00.41.492L4.5 16H5v-5zm14.5 0H19v5h.5a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5z"
        fill={color}
      />
    </svg>
  )
}

export default SvgCustomerService
